import { InvestmentProjectMessage } from "../../api/HomePageResponseTypes";
import { DateString } from "../../util/conversionUtils";

export interface InvestmentProjectMessageMapped extends Omit<InvestmentProjectMessage, "saadetud"> {
  saadetud: DateString;
}

export enum ColumnHeader {
  ipCode = "complexCode",
  sent = "sent",
  content = "content",
  comment = "comment",
  recepient = "recepient",
}
